import axios from "axios"
import { BASE_URL } from "../index"

export const getDeviceList = async () => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetDeviceTypeList`
    );

    return response.data.resultSet || [];
}

export const getPowerMeterReadings = async () => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetCDLPowerMeterFilter`
    );

    return response.data.resultSet || [];
}

export const getLiveDeviceReading = async (deviceId) => {
    const response = await axios.get(
        `${BASE_URL}/PowerMeter/GetLiveMeterFilter`, 
        {
            params: {
                did: deviceId
            }
        }
    );

    return response.data.resultSet?.[0] || null;
}